namespace TabAurous.Production {
    export namespace WIPMovementTreeMakingService {
        export const baseUrl = 'Production/WIPMovementTreeMaking';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPMovementTreeMaking/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPMovementTreeMakingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
